module.exports = __webpack_public_path__ + "img/miyama.a31b29a0.png";